import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'safeEmail',
})
export class SafeEmailPipe implements PipeTransform {
  transform(unsafeEmail: string | undefined) {
    if (!unsafeEmail) {
      return 'N.A.';
    }
    return unsafeEmail.replace(/@/g, '[at]').replace(/\./g, '[dot]');
  }
}
